import { useState, useEffect } from 'react';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Serviços', href: '#servicos' },
    { label: 'Sobre', href: '#sobre' },
    { label: 'Galeria', href: '#galeria' },
    { label: 'Contato', href: '#contato' },
  ];

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <header
        className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
          scrolled ? 'bg-[#0a0a0a]/95 backdrop-blur-md border-b border-white/10' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#hero" onClick={() => handleNav('#hero')} className="flex items-center gap-3 cursor-pointer">
            <span className="text-white font-bold text-xl tracking-wide leading-tight">
              Drone <span className="text-[#f5a623]">Fácil</span> SP
            </span>
            <img
              src="https://storage.readdy-site.link/project_files/d1351590-8cd2-45d9-bbe4-eacb238e475e/23228cbd-20e5-4c8b-8bb7-51ecf69320b6_Logo-da-Drone-Fcil.png?v=7d5630757adfff944c23036cb8ec71af"
              alt="Drone Fácil SP Logo"
              className="h-14 w-auto object-contain bg-white rounded-lg px-2 py-1"
            />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.label}
                onClick={() => handleNav(link.href)}
                className="text-white/80 hover:text-white text-sm font-medium tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </button>
            ))}
          </nav>

          {/* CTA Button */}
          <a
            href="https://wa.me/5511954283481?text=Ol%C3%A1%2C%20tenho%20interesse%20nos%20servi%C3%A7os%20de%20drone"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden md:flex items-center gap-2 bg-[#f5a623] hover:bg-[#e09510] text-black font-semibold text-sm px-5 py-2.5 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-base"></i>
            Solicitar Orçamento
          </a>

          {/* Mobile Hamburger */}
          <button
            className="md:hidden text-white text-2xl cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            <i className={menuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>
        </div>
      </header>

      {/* Mobile Menu — fora do header para não sobresair imagens */}
      {menuOpen && (
        <div className="md:hidden fixed top-20 left-0 w-full z-40 bg-[#0a0a0a] border-t border-white/10 px-6 py-6 flex flex-col gap-5">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => handleNav(link.href)}
              className="text-white/80 hover:text-white text-base font-medium text-left cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
          <a
            href="https://wa.me/5511954283481?text=Ol%C3%A1%2C%20tenho%20interesse%20nos%20servi%C3%A7os%20de%20drone"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 bg-[#f5a623] text-black font-semibold text-sm px-5 py-3 rounded-full whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-base"></i>
            Solicitar Orçamento
          </a>
        </div>
      )}
    </>
  );
};

export default Navbar;
